/* Frietbooster shared cart util — used by favorite-reorder, cart-upsell (S2), and future
 * app-parity sections. Adds items via /cart/add.js with Bundled Section Rendering so the
 * cart drawer refreshes without a page reload, then syncs the theme's toolbar count.
 * (When replicating to the other stores, rename file + global to match the store.)
 *
 * API:
 *   FrietboosterCart.add(items[, opts]) -> Promise<cartAddResponse>
 *     items: variant id (number/string) | {id, quantity} | array of {id, quantity}
 *     opts.openDrawer (default true): open the cart drawer after a successful add
 * On success also dispatches document event 'cart:refresh' with {detail: response}.
 */
(function () {
  'use strict';
  if (window.FrietboosterCart) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function normalizeItems(items) {
    if (Array.isArray(items)) return items;
    if (typeof items === 'object' && items !== null) return [items];
    return [{ id: parseInt(items, 10), quantity: 1 }];
  }

  function refreshDrawer(data) {
    /* Inject fresh cart-drawer HTML from the Bundled Section Rendering response */
    var sections = data && data.sections;
    if (sections && sections['cart-drawer']) {
      var tmp = document.createElement('div');
      tmp.innerHTML = sections['cart-drawer'];
      var newSummary = tmp.querySelector('.cart-summary');
      var existing = document.querySelector('.cart-summary');
      if (newSummary && existing) existing.replaceWith(newSummary);
    }
  }

  function openDrawer() {
    document.body.classList.add('show-cart-summary', 'product-added-to-cart');
    setTimeout(function () {
      var closeBtn = document.querySelector('.cart-summary__close');
      if (closeBtn) closeBtn.focus();
    }, 200);
  }

  function syncTheme(data) {
    /* jQuery-based theme listeners (toolbar count, qty adjusters) */
    if (window.$ && window.$(window).trigger) {
      window.$(window).trigger('cc-cart-updated', { addedToCart: true });
    }
    /* Canopy fallback — update toolbar cart count + re-init form bindings */
    if (window.theme && typeof window.theme.updateCartSummaries === 'function') {
      window.theme.updateCartSummaries(false, false, false);
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
  }

  var toastTimer = null;
  /* Korte periode waarin toasts onderdrukt worden. Gebruikt wanneer we de
     gesloten-modal tonen: de aanroepers vuren daarna hun eigen generieke
     foutmelding af, en die hoort niet achter de modal te verschijnen. */
  var suppressToastUntil = 0;

  function showToast(message, opts) {
    if (Date.now() < suppressToastUntil) return null;
    /* Lightweight cart toast shared across cart-add surfaces (re-order, upsell).
       Styling lives in the surface's CSS (.frietbooster-toast).
       opts.actionLabel + opts.onAction render an inline action (e.g. undo);
       opts.duration overrides the auto-dismiss (default 2200ms, 5000 with an action). */
    opts = opts || {};
    var el = document.querySelector('.frietbooster-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'frietbooster-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = '';
    var text = document.createElement('span');
    text.className = 'frietbooster-toast__text';
    text.textContent = message;
    el.appendChild(text);

    if (opts.actionLabel && typeof opts.onAction === 'function') {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'frietbooster-toast__action';
      btn.textContent = opts.actionLabel;
      btn.addEventListener('click', function () {
        hideToast(el);
        opts.onAction();
      });
      el.appendChild(btn);
    }

    /* force reflow so re-triggering the animation works */
    void el.offsetWidth;
    el.classList.add('frietbooster-toast--show');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      hideToast(el);
    }, opts.duration || (opts.actionLabel ? 5000 : 2200));
  }

  function hideToast(el) {
    el = el || document.querySelector('.frietbooster-toast');
    if (el) el.classList.remove('frietbooster-toast--show');
  }

  function mergeSections(extra) {
    /* Always refresh the drawer; callers can request additional sections
       (e.g. 'main-cart' on the cart page) via opts.sections. */
    var list = ['cart-drawer'];
    if (extra) {
      (Array.isArray(extra) ? extra : [extra]).forEach(function (s) {
        if (s && list.indexOf(s) === -1) list.push(s);
      });
    }
    return list.join(',');
  }

  window.FrietboosterCart = {
    toast: showToast,
    hideToast: hideToast,
    add: function (items, opts) {
      opts = opts || {};
      /* Winkel vandaag gesloten → niets toevoegen, waar de knop ook vandaan komt.
         Vlag wordt in layout/theme.liquid gezet vanuit de Closing days-instellingen. */
      var closed = window.FrietboosterClosed;
      if (closed) {
        /* Liefst dezelfde modal als op de menupagina — dat leest als uitleg,
           niet als een fout. Staat die modal er niet (andere pagina), dan valt
           het terug op een toast. */
        var shownAsModal = false;
        try {
          if (typeof window.FrietboosterShowClosed === 'function') {
            shownAsModal = window.FrietboosterShowClosed() === true;
          }
          if (!shownAsModal) {
            var M = window.FrietboosterMenu;
            if (M && typeof M.openClosedModal === 'function' &&
                document.getElementById('frietbooster-closed-modal')) {
              M.openClosedModal();
              shownAsModal = true;
            }
          }
        } catch (e) {}

        if (shownAsModal) {
          /* Slik de generieke foutmelding van de aanroeper op. */
          suppressToastUntil = Date.now() + 600;
        } else {
          /* Aanroeper toont zijn eigen foutmelding eerst; die van ons moet erna. */
          window.setTimeout(function () {
            try {
              var msg = closed.title || 'Vandaag gesloten';
              if (closed.body) { msg += ' — ' + closed.body; }
              showToast(msg, { duration: 5000 });
            } catch (e) {}
          }, 80);
        }
        return Promise.reject(new Error('shop_closed'));
      }
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: normalizeItems(items),
          sections: mergeSections(opts.sections)
        })
      }).then(function (res) {
        if (!res.ok) throw res;
        return res.json();
      }).then(function (data) {
        refreshDrawer(data);
        if (opts.openDrawer !== false) openDrawer();
        syncTheme(data);
        return data;
      });
    },
    /* Set an absolute quantity for a line (by line key or id). Used for undo. */
    change: function (idOrKey, quantity, opts) {
      opts = opts || {};
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: idOrKey,
          quantity: quantity,
          sections: mergeSections(opts.sections)
        })
      }).then(function (res) {
        if (!res.ok) throw res;
        return res.json();
      }).then(function (data) {
        refreshDrawer(data);
        syncTheme(data);
        return data;
      });
    }
  };
})();
